import {ReportFilterModel} from '../../shared/models/reportFilter.model';

export class GetCustomerSalesReport {
  static readonly type = '[Reports] Get Customer Sales Report';
}

export class DownloadCustomerSalesReport {
  static readonly type = '[Reports] Download Customer Sales Report File';
}

export class SetCustomerSalesReportFilter {
  static readonly type = '[Reports] Set Customer Sales Report Filter';

  constructor(public filter: ReportFilterModel) {
  }
}
